module.exports = __webpack_public_path__ + "img/login.71dba5d2.png";